import script from "./AdminFormElementTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementTable.vue?vue&type=style&index=0&id=e168641a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e168641a"]])

export default __exports__